import { render, staticRenderFns } from "./OrderManagement.vue?vue&type=template&id=2f0908fe&scoped=true"
import script from "./OrderManagement.vue?vue&type=script&lang=js"
export * from "./OrderManagement.vue?vue&type=script&lang=js"
import style0 from "./OrderManagement.vue?vue&type=style&index=0&id=2f0908fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0908fe",
  null
  
)

export default component.exports